<div class="report max-w-screen-lg">

    <h3>Board Summary (Data)</h3>

    <br>

    <div class="container-columns">
        <div class="column left">

            <app-report-range-selector [initialDateRange]="initialDateRange"
                                       [emitInitialDateRange]="true"
                                       (selected)="selectDateRange($event)"></app-report-range-selector>
        </div>

        <div class="column right">


        </div>
    </div>

    <br>

    <div *ngIf="!basicDataLoaded || !stats">

        <br>

        <p-progress-spinner
                strokeWidth="4"
                fill="transparent"
                animationDuration=".5s"
                [style]="{ width: '50px', height: '50px' }"/>
    </div>

    <div *ngIf="basicDataLoaded && stats">

        <div class="date-range" *ngIf="dateRange">
            <p *ngIf="dateRange.rangeFrom">From: {{ dateRange.rangeFrom | date: 'shortDate' }}</p>
            <p *ngIf="dateRange.rangeTo">To: {{ dateRange.rangeTo | date: 'shortDate' }}</p>
        </div>

        <div class="comparable-date-range" *ngIf="comparableDateRange">
            <br>
            <p>Comparable range:</p>
            <p *ngIf="comparableDateRange.rangeFrom">From: {{ comparableDateRange.rangeFrom | date: 'shortDate' }}</p>
            <p *ngIf="comparableDateRange.rangeTo">To: {{ comparableDateRange.rangeTo | date: 'shortDate' }}</p>
        </div>

        <br>

        <div class="mb-3">

            <p-selectbutton
                    [options]="aggregationLevels"
                    [(ngModel)]="selectedAggregationLevel"
                    (onChange)="selectAggregationLevel($event.value)"
                    optionLabel="label"
                    optionValue="value"></p-selectbutton>
        </div>

        <p-tabs value="0">

            <p-tablist>
                <p-tab value="0">Cards</p-tab>
                <p-tab value="1">Overdue Cards</p-tab>
                <p-tab value="2">Comments</p-tab>
                <p-tab value="3">Attachments</p-tab>
                <p-tab value="4">Labels</p-tab>
                <p-tab value="5">Lists</p-tab>
                <p-tab value="6">Members</p-tab>
                <p-tab value="7">Stages</p-tab>
            </p-tablist>

            <p-tabpanels>

                <p-tabpanel value="0">

                    <!-- cards -->

                    <section class="cards padded">

                        <app-totals-insight-panel
                                [chartData]="{ chartData: cardChartData.totalCards }"
                                [title]="'Total Cards'"
                                [icon]="'far fa-layer-group'"
                                [totals]="stats!.board.card.total"
                                [comparableTotals]="comparableStats?.board?.card?.total"
                                [tiled]="false">
                        </app-totals-insight-panel>

                        <div class="cards-summary">

                            <div class="total-cards">

                                <div class="chart">

                                    <h6>Board Activity Heatmap</h6>

                                    <div #boardActivityHeatmap style="height: 200px; margin-bottom: 2em;">
                                        <app-date-range-heatmap-chart-with-table
                                                [chartData]="boardActivityHeatmapData"
                                                [chartContainer]="boardActivityHeatmap"
                                                [minDate]="dateRange?.rangeFrom"
                                                [maxDate]="dateRange?.rangeTo"
                                                [tableTitle]="'Board Activity'">
                                        </app-date-range-heatmap-chart-with-table>
                                    </div>
                                </div>

                                <div class="chart">

                                    <h6>Trend Of Total Cards</h6>

                                    <app-trend-chart-with-table *ngIf="someKeys(stats!.board.card.total.day)"
                                                                [chartData]="{
                                                                  chartData: cardChartData.totalCards,
                                                                  chartLabel: 'Cards',
                                                                  tableData: stats!.board.card.total.day,
                                                                  tableColumnLabel: '# Cards',
                                                                }"
                                                                [tableTitle]="'Total Cards Per Day'"
                                                                [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                                </div>

                                <div class="chart">

                                    <h6>Cycle time by completion date</h6>

                                    <app-min-avg-max-bar-chart-with-table [chartData]="cycleTimeByCompletionDateChartData"
                                                                          [chartLegend]="false"
                                                                          [tableTitle]="'Cycle time by completion date'"
                                                                          [valueFormat]="'human-readable-time'"
                                                                          [valueUnit]="'milliseconds'"></app-min-avg-max-bar-chart-with-table>
                                </div>

                                <h6>Cards Created vs Archived</h6>

                                <p>
                                    Cards Created During Period<span class="colon">:</span>
                                    {{ (stats!.board.card.created | uniqueCount) || 0 }}
                                </p>

                                <p>
                                    Cards Archived During Period<span class="colon">:</span>
                                    {{ (stats!.board.card.closed | uniqueCount) || 0 }}
                                </p>

                                <app-change-chart-with-table *ngIf="someKeys(stats!.board.card.created) || someKeys(stats!.board.card.closed)"
                                                             [chartData]="[{
                                                               chartData: cardChartData.created,
                                                               chartLabel: 'Cards Created',
                                                               tableData: stats!.board.card.created,
                                                               tableColumnLabel: '# Cards Created',
                                                             },{
                                                               chartData: cardChartData.closed,
                                                               chartLabel: 'Cards Archived',
                                                               tableData: stats!.board.card.closed,
                                                               tableColumnLabel: '# Cards Archived',
                                                             }]"
                                                             [tableTitle]="'Cards Created vs Archived Per Day'"
                                                             [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                <h6>Cards Created</h6>

                                <p>
                                    Cards Created During Period<span class="colon">:</span>
                                    {{ (stats!.board.card.created | uniqueCount) || 0 }}
                                </p>

                                <div class="chart">

                                    <h6>Cards Created</h6>

                                    <div #heatmap style="height: 200px; margin-bottom: 2em;">

                                        <app-date-range-heatmap-chart-with-table [chartData]="stats!.board.card.created"
                                                                                 [chartContainer]="heatmap"
                                                                                 [minDate]="dateRange?.rangeFrom"
                                                                                 [maxDate]="dateRange?.rangeTo"
                                                                                 [tableTitle]="'Cards Created'"></app-date-range-heatmap-chart-with-table>
                                    </div>
                                </div>

                                <app-change-chart-with-table *ngIf="someKeys(stats!.board.card.created)"
                                                             [chartData]="{
                                                               chartData: cardChartData.created,
                                                               chartLabel: 'Cards Created',
                                                               tableData: stats!.board.card.created,
                                                               tableColumnLabel: '# Cards Created',
                                                             }"
                                                             [tableTitle]="'Cards Created Per Day'"
                                                             [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                <h6>Cards Archived</h6>

                                <p>
                                    Cards Archived During Period<span class="colon">:</span>
                                    {{ (stats!.board.card.closed | uniqueCount) || 0 }}
                                </p>

                                <app-change-chart-with-table *ngIf="someKeys(stats!.board.card.closed)"
                                                             [chartData]="{
                                                               chartData: cardChartData.closed,
                                                               chartLabel: 'Cards Archived',
                                                               tableData: stats!.board.card.closed,
                                                               tableColumnLabel: '# Cards Archived',
                                                             }"
                                                             [tableTitle]="'Cards Archived Per Day'"
                                                             [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                            </div>

                        </div>

                    </section>

                </p-tabpanel>

                <p-tabpanel value="1">

                    <!-- overdue -->

                    <section class="overdue-cards padded">

                        <app-totals-insight-panel
                                [chartData]="{ chartData: overdueChartData.totalCards }"
                                [title]="'Overdue Cards'"
                                [icon]="'far fa-clock'"
                                [totals]="stats!.board.overdue.total"
                                [comparableTotals]="comparableStats?.board?.overdue?.total"
                                [lessIsMore]="true"
                                [tiled]="false">
                        </app-totals-insight-panel>

                        <div>

                            <h6>Trend Of Total Overdue Cards</h6>

                            <app-trend-chart-with-table *ngIf="someKeys(stats!.board.overdue.total.day)"
                                                        [chartData]="{
                                                          chartData: overdueChartData.totalCards,
                                                          chartLabel: 'Overdue Cards',
                                                          tableData: stats!.board.overdue.total.day,
                                                          tableColumnLabel: '# Cards Overdue',
                                                        }"
                                                        [tableTitle]="'Total Overdue Cards Per Day'"
                                                        [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                        </div>

                        <div>

                            <h6>Cards Overdue at Start vs Became Overdue During Period</h6>

                            <app-pie-chart-with-table *ngIf="someKeys(stats!.board.overdue.becameOverdue)"
                                                      [chartData]="{
                                                        chartData: overdueChartData.totalOverdueVsBecameOverdue,
                                                        chartLabel: 'Cards',
                                                      }"></app-pie-chart-with-table>
                        </div>

                        <h6>Became Overdue</h6>

                        <p>
                            Cards Became Overdue During Period<span class="colon">:</span>
                            {{ (stats!.board.overdue.becameOverdue | uniqueCount) || 0 }}
                        </p>

                        <app-change-chart-with-table *ngIf="someKeys(stats!.board.overdue.becameOverdue)"
                                                     [chartData]="{
                                                       chartData: overdueChartData.becameOverdue,
                                                       chartLabel: 'Cards Became Overdue',
                                                       tableData: stats!.board.overdue.becameOverdue,
                                                       tableColumnLabel: '# Cards Became Overdue',
                                                     }"
                                                     [tableTitle]="'Cards Became Overdue Per Day'"
                                                     [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                        <h6>Overdue Duration</h6>

                        <p>
                            Total Duration Cards Were Overdue During Period<span class="colon">:</span>
                            {{ (stats!.board.overdue.duration | total | toSeconds | readableSeconds) || 'n/a' }}
                        </p>

                        <app-durations-chart-with-table *ngIf="someKeys(stats!.board.overdue.duration)"
                                                        [chartData]="{
                                                          chartData: overdueChartData.duration,
                                                          chartLabel: 'Total Duration',
                                                          tableData: stats!.board.overdue.duration,
                                                          tableColumnLabel: 'Total Duration',
                                                        }"
                                                        [tableTitle]="'Total Duration Cards Were Overdue Per Day'"
                                                        [tableGroupColumnLabel]="'Date'"></app-durations-chart-with-table>

                    </section>

                </p-tabpanel>

                <p-tabpanel value="2">

                    <!-- comments -->

                    <section class="comments padded">

                        <app-totals-insight-panel
                                [chartData]="{ chartData: commentChartData.totalComments }"
                                [title]="'Comments'"
                                [icon]="'far fa-comment'"
                                [totals]="stats!.board.comment.total"
                                [comparableTotals]="comparableStats?.board?.comment?.total"
                                [tiled]="false">
                        </app-totals-insight-panel>

                        <div>

                            <h6>Trend Of Total Comments</h6>

                            <app-trend-chart-with-table *ngIf="someKeys(stats!.board.comment.total.day)"
                                                        [chartData]="{
                                                          chartData: commentChartData.totalComments,
                                                          chartLabel: 'Comments',
                                                          tableData: stats!.board.comment.total.day,
                                                          tableColumnLabel: '# Comments',
                                                        }"
                                                        [tableTitle]="'Total Comments Per Day'"
                                                        [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                        </div>

                        <h6>Comments Added</h6>

                        <p>
                            Comments Added During Period<span class="colon">:</span>
                            {{ stats!.board.comment.added | uniqueCount }}
                        </p>

                        <app-change-chart-with-table *ngIf="someKeys(stats!.board.comment.added)"
                                                     [chartData]="{
                                                       chartData: commentChartData.added,
                                                       chartLabel: 'Comments',
                                                       tableData: stats!.board.comment.added,
                                                       tableColumnLabel: '# Comments Added',
                                                     }"
                                                     [tableTitle]="'Comments Added Per Day'"
                                                     [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                    </section>

                </p-tabpanel>

                <p-tabpanel value="3">

                    <!-- attachments -->

                    <section class="attachments padded">

                        <app-totals-insight-panel
                                [chartData]="{ chartData: attachmentChartData.totalAttachments }"
                                [title]="'Attachments'"
                                [icon]="'far fa-paperclip'"
                                [totals]="stats!.board.attachment.total"
                                [comparableTotals]="comparableStats?.board?.attachment?.total"
                                [tiled]="false">
                        </app-totals-insight-panel>

                        <div>

                            <h6>Trend Of Total Attachments</h6>

                            <app-trend-chart-with-table *ngIf="someKeys(stats!.board.attachment.total.day)"
                                                        [chartData]="{
                                                          chartData: attachmentChartData.totalAttachments,
                                                          chartLabel: 'Attachments',
                                                          tableData: stats!.board.attachment.total.day,
                                                          tableColumnLabel: '# Attachments',
                                                        }"
                                                        [tableTitle]="'Total Attachments Per Day'"
                                                        [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                        </div>

                        <h6>Attachments Added</h6>

                        <p>
                            Attachments Added During Period<span class="colon">:</span>
                            {{ (stats!.board.attachment.added | uniqueCount) || 0 }}
                        </p>

                        <app-change-chart-with-table *ngIf="someKeys(stats!.board.attachment.added)"
                                                     [chartData]="{
                                                       chartData: attachmentChartData.added,
                                                       chartLabel: 'Attachments',
                                                       tableData: stats!.board.attachment.added,
                                                       tableColumnLabel: '# Attachments Added',
                                                     }"
                                                     [tableTitle]="'Attachments Added Per Day'"
                                                     [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                    </section>

                </p-tabpanel>

                <p-tabpanel value="4">

                    <!-- labels -->

                    <br>

                    <div>

                        <h6>Top 5 Labels</h6>

                        <app-pie-chart-with-table [chartData]="combinedLabelCountChartDataByPeriod"
                                                  [limit]="5"></app-pie-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Total Cards With Label (Combined)</h6>

                        <app-change-chart-with-table [chartData]="combinedLabelCountChartDataByPeriod"
                                                     [chartLegend]="false"
                                                     [horizontal]="true"></app-change-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Total Cards With Label (Over Time)</h6>

                        <app-change-chart-with-table [chartData]="combinedLabelCountChartDataByLevel"
                                                     [chartLegend]="true"></app-change-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Trend Of Cards With Label (Over Time)</h6>

                        <app-trend-chart-with-table [chartData]="combinedLabelCountChartDataByLevel"
                                                    [chartLegend]="true"></app-trend-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Trend Of Cards With Label (Over Time)</h6>

                        <app-trend-chart-with-table [chartData]="combinedLabelCountChartDataByLevel"
                                                    [chartLegend]="true"
                                                    [fill]="true"
                                                    [stacked]="true"></app-trend-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Labels Added During Period</h6>

                        <app-change-chart-with-table [chartData]="combinedLabelAddedChartDataByLevel"
                                                     [chartLegend]="false"
                                                     [stacked]="true"></app-change-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Label Durations</h6>

                        <app-durations-chart-with-table [chartData]="combinedLabelDurationChartData"
                                                        [tableTitle]="'Label Durations'"
                                                        [tableGroupColumnLabel]="'Date'"></app-durations-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Label Durations (Min/Max bars)</h6>

                        <app-min-avg-max-bar-chart-with-table [chartData]="combinedLabelDurationMinAvgMaxChartData"
                                                              [tableTitle]="'Label Durations'"
                                                              [tableGroupColumnLabel]="'Date'"
                                                              [valueFormat]="'human-readable-time'"
                                                              [valueUnit]="'milliseconds'"></app-min-avg-max-bar-chart-with-table>
                    </div>

                    <br>

                    <div>

                        <h6>Label Durations (Min/Max points)</h6>

                        <app-min-avg-max-point-chart-with-table [chartData]="combinedLabelDurationMinAvgMaxChartData"
                                                                [tableTitle]="'Label Durations'"
                                                                [tableGroupColumnLabel]="'Date'"
                                                                [valueFormat]="'human-readable-time'"
                                                                [valueUnit]="'milliseconds'"></app-min-avg-max-point-chart-with-table>
                    </div>

                    <br>

                    <p-accordion [multiple]="true">
                        @for (label of labels; track label.labelId) {
                            @if (stats!.labels[label.labelId]) {
                                <p-accordion-panel [value]="label.labelId">

                                    <p-accordion-header>

                                        <app-totals-insight-panel
                                                [chartData]="{ chartData: labelChartDataById.get(label.labelId)?.totalCards! }"
                                                [title]="'Cards With Label “' + labelName(label.labelId) + '”'"
                                                [icon]="'fa fa-tag label_foreground ' + labelColor(label.labelId)"
                                                [totals]="statsForLabel(label.labelId).label.total"
                                                [comparableTotals]="comparableStatsForLabel(label.labelId)?.label?.total"
                                                [tiled]="false">
                                        </app-totals-insight-panel>

                                    </p-accordion-header>

                                    <p-accordion-content>

                                        <section class="label"
                                                 [id]="'label-' + label.labelId">

                                            <div class="chart">

                                                <h6>{{ 'Trend Of Total Cards With Label “' + labelName(label.labelId) + '”' }}</h6>

                                                <app-trend-chart-with-table *ngIf="someKeys(stats!.labels[label.labelId].label.total.day)"
                                                                            [chartData]="{
                                                                              chartData: labelChartDataById.get(label.labelId)?.totalCards!,
                                                                              chartLabel: 'Cards',
                                                                              tableData: stats!.labels[label.labelId].label.total.day,
                                                                              tableColumnLabel: '# Cards',
                                                                            }"
                                                                            [tableTitle]="'Total Cards With Label “' + labelName(label.labelId) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                                            </div>

                                            <h6>Label “{{ labelName(label.labelId) }}” Added</h6>

                                            <p>
                                                Label Added To Cards During Period<span class="colon">:</span>
                                                {{ (stats!.labels[label.labelId].label.added | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.labels[label.labelId].label.added)"
                                                                         [chartData]="{
                                                                           chartData: labelChartDataById.get(label.labelId)?.added!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.labels[label.labelId].label.added,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards With Label “' + labelName(label.labelId) + '” Added Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Label “{{ labelName(label.labelId) }}” Removed</h6>

                                            <p>
                                                Label Removed From Cards During Period<span class="colon">:</span>
                                                {{ (stats!.labels[label.labelId].label.removed | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.labels[label.labelId].label.removed)"
                                                                         [chartData]="{
                                                                           chartData: labelChartDataById.get(label.labelId)?.removed!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.labels[label.labelId].label.removed,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards With Label “' + labelName(label.labelId) + '” Removed Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Duration Had Label “{{ labelName(label.labelId) }}”</h6>

                                            <p>
                                                Total Duration Cards Had Label During Period<span class="colon">:</span>
                                                {{ (stats!.labels[label.labelId].label.duration | total | toSeconds | readableSeconds) || 'n/a' }}
                                            </p>

                                            <app-durations-chart-with-table *ngIf="someKeys(stats!.labels[label.labelId].label.duration)"
                                                                            [chartData]="{
                                                                              chartLabel: 'Total Duration',
                                                                              chartData: labelChartDataById.get(label.labelId)?.duration!,
                                                                              tableColumnLabel: 'Total Duration',
                                                                              tableData: stats!.labels[label.labelId].label.duration,
                                                                            }"
                                                                            [tableTitle]="'Total Duration Cards Had Label “' + labelName(label.labelId) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-durations-chart-with-table>

                                        </section>

                                    </p-accordion-content>

                                </p-accordion-panel>
                            }
                        }
                    </p-accordion>

                </p-tabpanel>

                <p-tabpanel value="5">

                    <!-- lists -->

                    <p-accordion [multiple]="true">
                        @for (list of lists; track list.listId) {
                            @if (stats!.lists[list.listId]) {
                                <p-accordion-panel [value]="list.listId">

                                    <p-accordion-header>

                                        <app-totals-insight-panel
                                                [chartData]="{ chartData: listChartDataById.get(list.listId)?.totalCards! }"
                                                [title]="'Cards In List “' + listName(list.listId) + '”'"
                                                [icon]="'fa fa-line-columns'"
                                                [totals]="statsForList(list.listId).list.total"
                                                [comparableTotals]="comparableStatsForList(list.listId)?.list?.total"
                                                [tiled]="false">
                                        </app-totals-insight-panel>

                                    </p-accordion-header>

                                    <p-accordion-content>

                                        <section class="list"
                                                 [id]="'list-' + list.listId">

                                            <div class="chart">

                                                <h6>{{ 'Trend Of Total Cards In List “' + listName(list.listId) + '”'' }}</h6>

                                                <app-trend-chart-with-table *ngIf="someKeys(stats!.lists[list.listId].list.total.day)"
                                                                            [chartData]="{
                                                                              chartData: listChartDataById.get(list.listId)?.totalCards!,
                                                                              chartLabel: 'Cards',
                                                                              tableData: stats!.lists[list.listId].list.total.day,
                                                                              tableColumnLabel: '# Cards',
                                                                            }"
                                                                            [tableTitle]="'Total Cards In List “' + listName(list.listId) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                                            </div>

                                            <h6>Moved Into List “{{ listName(list.listId) }}”</h6>

                                            <p>
                                                Cards Moved Into List During Period<span class="colon">:</span>
                                                {{ (stats!.lists[list.listId].list.movedIn | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.lists[list.listId].list.movedIn)"
                                                                         [chartData]="{
                                                                           chartData: listChartDataById.get(list.listId)?.movedIn!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.lists[list.listId].list.movedIn,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards Moved Into List “' + listName(list.listId) + '” Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Moved Out Of List “{{ listName(list.listId) }}”</h6>

                                            <p>
                                                Cards Moved Out Of List During Period<span class="colon">:</span>
                                                {{ (stats!.lists[list.listId].list.movedOut | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.lists[list.listId].list.movedOut)"
                                                                         [chartData]="{
                                                                           chartData: listChartDataById.get(list.listId)?.movedOut!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.lists[list.listId].list.movedOut,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards Moved Out Of List “' + listName(list.listId) + '” Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Duration In List “{{ listName(list.listId) }}”</h6>

                                            <p>
                                                Total Duration Cards In List During Period<span class="colon">:</span>
                                                {{ (stats!.lists[list.listId].list.duration | total | toSeconds | readableSeconds) || 'n/a' }}
                                            </p>

                                            <app-durations-chart-with-table *ngIf="someKeys(stats!.lists[list.listId].list.duration)"
                                                                            [chartData]="{
                                                                              chartLabel: 'Total Duration',
                                                                              chartData: listChartDataById.get(list.listId)?.duration!,
                                                                              tableColumnLabel: 'Total Duration',
                                                                              tableData: stats!.lists[list.listId].list.duration,
                                                                            }"
                                                                            [tableTitle]="'Total Duration Cards In List “' + listName(list.listId) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-durations-chart-with-table>

                                        </section>

                                    </p-accordion-content>

                                </p-accordion-panel>
                            }
                        }
                    </p-accordion>

                </p-tabpanel>

                <p-tabpanel value="6">

                    <!-- members -->

                    <br>

                    <div class="chart">

                        <h6>Cycle time by member</h6>

                        <div #cycleTimeByMember style="height: 120px; margin-bottom: 2em;">

                            <app-min-avg-max-bar-chart-with-table [chartData]="cycleTimeByMemberChartData"
                                                                  [chartContainer]="cycleTimeByMember"
                                                                  [chartLegend]="false"
                                                                  [horizontal]="true"
                                                                  [tableTitle]="'Cycle time by member'"
                                                                  [valueFormat]="'human-readable-time'"
                                                                  [valueUnit]="'milliseconds'"></app-min-avg-max-bar-chart-with-table>
                        </div>
                    </div>

                    <br>

                    <p-accordion [multiple]="true">
                        @for (member of members; track member.memberId) {
                            @if (stats!.members[member.memberId]) {
                                <p-accordion-panel [value]="member.memberId">

                                    <p-accordion-header>

                                        <app-totals-insight-panel
                                                [chartData]="{ chartData: memberChartDataById.get(member.memberId)?.totalCards! }"
                                                [title]="'Cards Assigned To “' + memberName(member.memberId) + '”'"
                                                [icon]="'fa fa-user'"
                                                [totals]="statsForMember(member.memberId).member.total"
                                                [comparableTotals]="comparableStatsForMember(member.memberId)?.member?.total"
                                                [tiled]="false">
                                        </app-totals-insight-panel>

                                    </p-accordion-header>

                                    <p-accordion-content>

                                        <section class="member"
                                                 [id]="'member-' + member.memberId">

                                            <div class="chart">

                                                <h6>{{ 'Trend Of Total Cards Assigned to “' + memberName(member.memberId) + '”' }}</h6>

                                                <app-trend-chart-with-table *ngIf="someKeys(stats!.members[member.memberId].member.total.day)"
                                                                            [chartData]="{
                                                                              chartData: memberChartDataById.get(member.memberId)?.totalCards!,
                                                                              chartLabel: 'Cards',
                                                                              tableData: stats!.members[member.memberId].member.total.day,
                                                                              tableColumnLabel: '# Cards',
                                                                            }"
                                                                            [tableTitle]="'Total Cards Assigned to “' + memberName(member.memberId) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                                            </div>

                                            <h6>Assigned To “{{ memberName(member.memberId) }}”</h6>

                                            <p>
                                                Cards Assigned To Member During Period<span class="colon">:</span>
                                                {{ (stats!.members[member.memberId].member.assigned | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.members[member.memberId].member.assigned)"
                                                                         [chartData]="{
                                                                           chartData: memberChartDataById.get(member.memberId)?.assigned!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.members[member.memberId].member.assigned,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards Assigned To “' + memberName(member.memberId) + '” Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Unassigned From “{{ memberName(member.memberId) }}”</h6>

                                            <p>
                                                Cards Unassigned From Member During Period<span class="colon">:</span>
                                                {{ (stats!.members[member.memberId].member.unassigned | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.members[member.memberId].member.unassigned)"
                                                                         [chartData]="{
                                                                           chartData: memberChartDataById.get(member.memberId)?.unassigned!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.members[member.memberId].member.unassigned,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards Unassigned From “' + memberName(member.memberId) + '” Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Duration Assigned To “{{ memberName(member.memberId) }}”</h6>

                                            <p>
                                                Total Duration Cards Assigned To Member During Period<span class="colon">:</span>
                                                {{ (stats!.members[member.memberId].member.duration | total | toSeconds | readableSeconds) || 'n/a' }}
                                            </p>

                                            <app-durations-chart-with-table *ngIf="someKeys(stats!.members[member.memberId].member.duration)"
                                                                            [chartData]="{
                                                                              chartLabel: 'Total Duration',
                                                                              chartData: memberChartDataById.get(member.memberId)?.duration!,
                                                                              tableColumnLabel: 'Total Duration',
                                                                              tableData: stats!.members[member.memberId].member.duration,
                                                                            }"
                                                                            [tableTitle]="'Total Duration Cards Assigned To “' + memberName(member.memberId) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-durations-chart-with-table>

                                        </section>

                                    </p-accordion-content>

                                </p-accordion-panel>
                            }
                        }
                    </p-accordion>

                </p-tabpanel>

                <p-tabpanel value="7">

                    <!-- stages -->

                    <br>

                    <div #progressionSplit class="progression-split">

                        <app-progression-split-chart [chartContainer]="progressionSplit"
                                                     [chartValues]="progressionChartData"></app-progression-split-chart>
                    </div>

                    <br>

                    <p-accordion class="detached" [multiple]="true">
                        @for (stage of stages; track stage) {
                            @if (stats!.stages[stage]) {
                                <p-accordion-panel [value]="stage">

                                    <p-accordion-header>

                                        <app-totals-insight-panel
                                                [chartData]="{ chartData: stageChartDataById.get(stage)?.totalCards! }"
                                                [title]="stageName(stage) + ' Cards'"
                                                [icon]="'fa fa-bars-staggered'"
                                                [totals]="statsForStage(stage).card.total"
                                                [comparableTotals]="comparableStatsForStage(stage)?.card?.total"
                                                [lessIsMore]="stage == 'pending'"
                                                [tiled]="false">
                                        </app-totals-insight-panel>

                                    </p-accordion-header>

                                    <p-accordion-content>

                                        <section class="stage"
                                                 [id]="'stage-' + stage">

                                            <div class="chart">

                                                <h6>{{ 'Trend Of Total Cards in Stage “' + stageName(stage) + '”' }}</h6>

                                                <app-trend-chart-with-table *ngIf="someKeys(stats!.stages[stage].stage.total.day)"
                                                                            [chartData]="{
                                                                              chartData: stageChartDataById.get(stage)?.totalCards!,
                                                                              chartLabel: 'Cards',
                                                                              tableData: stats!.stages[stage].stage.total.day,
                                                                              tableColumnLabel: '# Cards',
                                                                            }"
                                                                            [tableTitle]="'Total Cards in Stage “' + stageName(stage) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-trend-chart-with-table>
                                            </div>

                                            <br>

                                            <h6>Moved Into Stage “{{ stageName(stage) }}”</h6>

                                            <p>
                                                Cards Moved Into Stage During Period<span class="colon">:</span>
                                                {{ (stats!.stages[stage].stage.movedIn | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.stages[stage].stage.movedIn)"
                                                                         [chartData]="{
                                                                           chartData: stageChartDataById.get(stage)?.movedIn!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.stages[stage].stage.movedIn,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards Moved Into Stage “' + stageName(stage) + '” Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Moved Out Of Stage “{{ stageName(stage) }}”</h6>

                                            <p>
                                                Cards Moved Out Of Stage During Period<span class="colon">:</span>
                                                {{ (stats!.stages[stage].stage.movedOut | uniqueCount) || 0 }}
                                            </p>

                                            <app-change-chart-with-table *ngIf="someKeys(stats!.stages[stage].stage.movedOut)"
                                                                         [chartData]="{
                                                                           chartData: stageChartDataById.get(stage)?.movedOut!,
                                                                           chartLabel: 'Cards',
                                                                           tableData: stats!.stages[stage].stage.movedOut,
                                                                           tableColumnLabel: '# Cards',
                                                                         }"
                                                                         [tableTitle]="'Cards Moved Out Of Stage “' + stageName(stage) + '” Per Day'"
                                                                         [tableGroupColumnLabel]="'Date'"></app-change-chart-with-table>

                                            <h6>Duration In Stage “{{ stageName(stage) }}”</h6>

                                            <p>
                                                Total Duration Cards In Stage During Period<span class="colon">:</span>
                                                {{ (stats!.stages[stage].stage.duration | total | toSeconds | readableSeconds) || 'n/a' }}
                                            </p>

                                            <app-durations-chart-with-table *ngIf="someKeys(stats!.stages[stage].stage.duration)"
                                                                            [chartData]="{
                                                                              chartLabel: 'Total Duration',
                                                                              chartData: stageChartDataById.get(stage)?.duration!,
                                                                              tableColumnLabel: 'Total Duration',
                                                                              tableData: stats!.stages[stage].stage.duration,
                                                                            }"
                                                                            [tableTitle]="'Total Duration Cards In Stage “' + stageName(stage) + '” Per Day'"
                                                                            [tableGroupColumnLabel]="'Date'"></app-durations-chart-with-table>

                                        </section>

                                    </p-accordion-content>

                                </p-accordion-panel>
                            }
                        }
                    </p-accordion>

                </p-tabpanel>

            </p-tabpanels>
        </p-tabs>

    </div>

</div>
